import React from "react";
import { useNavigate } from "react-router-dom";
import { haptic } from "@/lib/haptic";
import { useDictionaryStats } from "@/hooks/useDictionaryStats";

const formatNumber = (num: number) => {
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + "k";
  }
  return num.toString();
};

const KnownWords: React.FC = () => {
  const nav = useNavigate();
  const { knownWordCount } = useDictionaryStats();

  const handleClick = () => {
    haptic.soft();
    nav("/home/dictionary");
  };

  return (
    <div
      onClick={handleClick}
      className="h-6 justify-start items-center inline-flex shadow-sm rounded-lg p-[4px] gap-1"
    >
      <div className="text-center text-sm font-semibold">
        🇪🇸 {formatNumber(knownWordCount)}
      </div>
    </div>
  );
};

export default KnownWords;
